<ng-template #imageModalFormContent let-modal>
  <div class="modal-body text-center">
    <lord-icon
      colors="primary:#121331,secondary:#08a88a"
      [src]="imageLink"
      style="width:120px;height:120px"
      trigger="loop"
    ></lord-icon>
    <div class="mt-4">
      <h4 class="mb-3">{{mainMessage}}</h4>
      <p class="text-muted mb-4">{{subMessage}}</p>
      <p class="text-muted mb-4">{{imageNumbering}}</p>
      <div class="hstack gap-2 justify-content-center mb-4">
        <button
          type="button"
          class="btn btn-link text-decoration-none btn-label previestab"
          [disabled]="selectedIndex<=0"
          (click)="previousClick()"
        >
          <i class="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>
          Previous
        </button>
        <button
          type="button"
          class="btn btn-success btn-label right ms-auto nexttab nexttab"
          [disabled]="selectedIndex>=maxIndex"
          (click)="nextClick()"
        >
          <i class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
          Next
        </button>
      </div>
      <div class="hstack gap-2 justify-content-center mb-4">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
      </div>
    </div>
  </div>
</ng-template>
